module.exports = __webpack_public_path__ + "img/blue_anime.gif";